import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Col, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";

function RecepcionLaredoCreate() {
  const { user } = useContext(AuthContext);
  const URL_RL        = process.env.REACT_APP_URL_RECEPCIONES_LAREDO;
  const URL_ARL       = process.env.REACT_APP_URL_ARTICULOS_RECEPCION_LAREDO;
  const URL_OC        = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_AOC       = process.env.REACT_APP_URL_ARTICULOS_OC;
  const URL_AOC_EMB   = `${process.env.REACT_APP_URL_ARTICULOS_OC}editEmbarcado`;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  const URL_VARIANTES = process.env.REACT_APP_URL_VARIANTES_ARTICULOS;

  const ocParam = new URLSearchParams(window.location.search).get("oc");

  const [ocInfo, setOcInfo] = useState(null);
  const [fecha, setFecha] = useState(new Date().toISOString().split("T")[0]);
  const [tipoCambio, setTipoCambio] = useState(0);
  const [noFactura, setNoFactura] = useState("");
  const [noGuia, setNoGuia] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [inputFields, setInputFields] = useState([]);

  useEffect(() => {
    if (ocParam) jalaOC(ocParam);
  }, []);

  async function jalaOC(ocId) {
    const auth = { headers: { Authorization: `Bearer ${localStorage.getItem("app_token")}` } };
    const [{ data: oc }, { data: artOCs }] = await Promise.all([
      axios.get(`${URL_OC}/${ocId}`, auth),
      axios.get(`${URL_AOC}/ordenesCompra/${ocId}`, auth),
    ]);
    setOcInfo(oc);
    if (oc.tipoCambio) setTipoCambio(oc.tipoCambio);
    if (oc.noFactura)  setNoFactura(oc.noFactura);

    const pendientes = artOCs.filter(a => a.pendiente_embarcar > 0);

    // Carga variantes de cada artículo único
    const uniqueIds = [...new Set(pendientes.map(a => a.articulos[0]._id))];
    const varMap = {};
    await Promise.all(uniqueIds.map(id =>
      axios.get(`${URL_VARIANTES}/articulo/${id}`, auth)
        .then(r => { varMap[id] = r.data; })
        .catch(() => { varMap[id] = []; })
    ));

    const fields = pendientes.map(a => ({
      idArticulosOC: a._id,
      idArticulo: a.articulos[0]._id,
      mlm: a.articulos[0].MLM,
      nombre: a.articulos[0].nombre,
      precio: a.precio,
      cantidad: a.pendiente_embarcar,
      total: a.precio * a.pendiente_embarcar,
      gastosEnvio: a.gastosEnvio || 0,
      gastosImportacion: a.gastosImportacion || 0,
      variante: a.variante || "",
      variantesOptions: varMap[a.articulos[0]._id] || [],
    }));
    setInputFields(fields);
  }

  function handleCantidad(index, val) {
    const rows = [...inputFields];
    rows[index].cantidad = parseFloat(val) || 0;
    rows[index].total = rows[index].precio * rows[index].cantidad;
    setInputFields(rows);
  }

  function handlePrecio(index, val) {
    const rows = [...inputFields];
    rows[index].precio = parseFloat(val) || 0;
    rows[index].total = rows[index].precio * rows[index].cantidad;
    setInputFields(rows);
  }

  function handleGastosEnvio(index, val) {
    const rows = [...inputFields];
    rows[index].gastosEnvio = parseFloat(val) || 0;
    setInputFields(rows);
  }

  function handleGastosImportacion(index, val) {
    const rows = [...inputFields];
    rows[index].gastosImportacion = parseFloat(val) || 0;
    setInputFields(rows);
  }

  function handleVariante(index, val) {
    const rows = [...inputFields];
    rows[index].variante = val;
    setInputFields(rows);
  }

  const total_cantidad = inputFields.reduce((s, r) => s + r.cantidad, 0);
  const total_general  = inputFields.reduce((s, r) => s + r.total, 0);

  async function saveRecepcion(e) {
    e.preventDefault();
    if (!ocParam) { Swal.fire("Error", "No se especificó la OC", "error"); return; }
    if (!inputFields.length) { Swal.fire("Error", "No hay artículos", "error"); return; }

    try {
      const rl = await axios.post(URL_RL, {
        ordenesCompra: ocParam,
        fecha, tipoCambio: parseFloat(tipoCambio) || 0,
        noFactura, noGuia,
        total_general, total_cantidad, observaciones,
        user: user.id,
      }, { headers: { Authorization: `Bearer ${localStorage.getItem("app_token")}` } });

      const rlId = rl.data._id;

      for (const row of inputFields) {
        if (row.cantidad <= 0) continue;
        await axios.post(URL_ARL, {
          recepcionLaredo: rlId,
          ordenesCompra: ocParam,
          articulos: row.idArticulo,
          cantidad: row.cantidad,
          recibido: 0,
          pendiente_recibir: row.cantidad,
          precio: row.precio,
          total: row.total,
          gastosEnvio: parseFloat(row.gastosEnvio) || 0,
          gastosImportacion: parseFloat(row.gastosImportacion) || 0,
          variante: row.variante || null,
        }, { headers: { Authorization: `Bearer ${localStorage.getItem("app_token")}` } });

        await axios.patch(`${process.env.REACT_APP_URL_ARTICULOS_OC}editEmbarcado/${row.idArticulosOC}`,
          { embarcado: row.cantidad, ordenesCompra: ocParam },
          { headers: { Authorization: `Bearer ${localStorage.getItem("app_token")}` } }
        );
      }

      Swal.fire({ icon: "success", title: "Recepción Bodega USA creada", timer: 1500, showConfirmButton: false });
      setTimeout(() => window.location.href = "/ListadoRecepcionesLaredo", 1600);
    } catch (err) {
      console.log(err);
      Swal.fire("Error", "No se pudo guardar la recepción", "error");
    }
  }

  return (
    <>
      <Header />
      <br /><br />
      {user.menu_compras ? (
        <div className="container">
          <div className="card container col-sm-10">
            <h4 className="text-center mt-3">
              Nueva Recepción{ocInfo?.destino?.nombre ? ` en ${ocInfo.destino.nombre}` : " en Destino"}
            </h4>
            {ocInfo && (
              <div className="alert alert-info py-2 mb-3" style={{ fontSize: "0.85rem" }}>
                <strong>OC #{ocInfo.idOrdenCompra}</strong> — {ocInfo.proveedores?.[0]?.nombre_comercial} — {ocInfo.fecha}
                {ocInfo.destino?.nombre && (
                  <span className="ms-2 badge bg-primary">{ocInfo.destino.nombre}</span>
                )}
              </div>
            )}
            <Form onSubmit={saveRecepcion}>
              <Row>
                <Col md={3}>
                  <FormGroup><Label>Fecha</Label>
                    <Input type="date" value={fecha} onChange={e => setFecha(e.target.value)} required />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup><Label>T.C. (USD→MXN)</Label>
                    <Input type="number" step="0.01" value={tipoCambio} onChange={e => setTipoCambio(e.target.value)} />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup><Label>No. Factura</Label>
                    <Input type="text" value={noFactura} onChange={e => setNoFactura(e.target.value)} />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup><Label>No. Guía / Tracking</Label>
                    <Input type="text" value={noGuia} onChange={e => setNoGuia(e.target.value)} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormGroup><Label>Observaciones</Label>
                    <Input type="text" value={observaciones} onChange={e => setObservaciones(e.target.value)} />
                  </FormGroup>
                </Col>
              </Row>

              <h6 className="mt-2">Artículos recibidos en Bodega USA</h6>
              <Table size="sm" bordered responsive>
                <thead>
                  <tr>
                    <th>MLM / Parent</th>
                    <th>Nombre</th>
                    <th>Variante</th>
                    <th style={{ width: 90 }}>Precio USD</th>
                    <th style={{ width: 100 }}>G. Envío USD</th>
                    <th style={{ width: 110 }}>G. Import. MXN</th>
                    <th style={{ width: 90 }}>Cantidad</th>
                    <th style={{ width: 90 }}>Total USD</th>
                  </tr>
                </thead>
                <tbody>
                  {inputFields.map((row, i) => (
                    <tr key={i}>
                      <td>{row.mlm}</td>
                      <td>{row.nombre}</td>
                      <td>
                        {row.variantesOptions && row.variantesOptions.length > 0 ? (
                          <Input bsSize="sm" type="select" value={row.variante}
                            onChange={e => handleVariante(i, e.target.value)}>
                            <option value="">Sin variante</option>
                            {row.variantesOptions.map(v => (
                              <option key={v._id} value={v._id}>{v.nombre}</option>
                            ))}
                          </Input>
                        ) : <span className="text-muted">—</span>}
                      </td>
                      <td>
                        <Input bsSize="sm" type="number" value={row.precio}
                          onChange={e => handlePrecio(i, e.target.value)} />
                      </td>
                      <td>
                        <Input bsSize="sm" type="number" min="0" step="any"
                          value={row.gastosEnvio}
                          onChange={e => handleGastosEnvio(i, e.target.value)} />
                      </td>
                      <td>
                        <Input bsSize="sm" type="number" min="0" step="any"
                          value={row.gastosImportacion}
                          onChange={e => handleGastosImportacion(i, e.target.value)} />
                      </td>
                      <td>
                        <Input bsSize="sm" type="number" value={row.cantidad}
                          onChange={e => handleCantidad(i, e.target.value)} />
                      </td>
                      <td>{new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(row.total)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan={3}><strong>Total</strong></td>
                    <td><strong>{total_cantidad}</strong></td>
                    <td><strong>{new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(total_general)}</strong></td>
                  </tr>
                </tfoot>
              </Table>

              <Row className="mt-3 mb-3">
                <Col>
                  <Button color="success" type="submit" size="sm">Guardar Recepción</Button>{" "}
                  <Button color="danger" size="sm" href="/ListadoOrdenesCompra">Cancelar</Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      ) : <p className="text-muted ms-3">Sin acceso.</p>}
    </>
  );
}

export default RecepcionLaredoCreate;
